module.exports = {
    yourCourses: 'Your courses',
    instruction1: 'Select a course to view or edit it.',
    seeAll: 'See all',
    noCourses: 'You have no courses! Create one right now using the button below.',
    newCourse: 'New course',
    instruction2: 'Create a new course quickly and easily.',
    createNewCourse: 'Create new course',
}